import createReactComponent from '../createReactComponent';
export default createReactComponent('danger', 'Danger', [["path",{"d":"M12 19v-.5M12 5v10","key":"svg-0"}]]);